import { CAN_USE_DOM } from '@lexical/utils';

// TODO: import from "lexical" after upgrade to >0.20
export function getDOMSelection(targetWindow: null | Window): null | Selection {
  return !CAN_USE_DOM ? null : (targetWindow || window).getSelection();
}
